export default __webpack_public_path__ + "static/media/baby-33.de2c2144.svg";